class RentalsFormOption extends HTMLElement {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
  }

  get value() {
    return this.getAttribute('value');
  }

  set value(value) {
    if (value) {
      this.setAttribute('value', value);
    } else {
      this.removeAttribute('value');
    }
  }

  get name() {
    return this.getAttribute('name');
  }

  get min() {
    return this.getAttribute('min');
  }

  get max() {
    return this.getAttribute('max');
  }

  get selected() {
    return this.hasAttribute('selected');
  }

  set selected(value) {
    if (value) {
      this.setAttribute('selected', value);
    } else {
      this.removeAttribute('selected');
    }
  }

  get kind() {
    return this.getAttribute('kind');
  }

  connectedCallback() {
    const params = new URLSearchParams(document.location.search);
    const paramValue = params.get(this.name);

    if (paramValue && !this.value) {
      this.value = paramValue;
      this.selected = !!paramValue;
    }

    this.classList.toggle('active', this.selected);
  }

  static get observedAttributes() {
    return ['selected', 'value'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.classList.toggle('active', newValue);
      this.dispatchEvent(new Event(name === 'selected' ? 'selected' : 'valueChanged'));
    }
  }
}

customElements.define('rentals-form-option', RentalsFormOption);
